import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import InputMask from "inputmask";

export default class extends Controller {
  connect() {
    this.maskBsbInput();
  }

  static targets = ["creditCardSubmit", "bpointForm"];

  switchDirectDebitType(event) {
    const type = event.target.value;
    if (type == "bankaccount") {
      $(".bpoint-bank-account-container").show();
      $(".bpoint-credit-card-container").hide();
    } else {
      $(".bpoint-bank-account-container").hide();
      $(".bpoint-credit-card-container").show();
    }
  }

  saveBankAccountDirectDebit(event) {
    event.preventDefault();
    const form = $(".bank-account-form");
    if (validateBankAccountForm(form)) {
      this.toggle_spinner(form);
      const url = this.data.get("url");
      const redirectUrl = this.data.get("redirectUrl");

      axios
        .patch(url, form.serialize())
        .then(response => {
          bootbox.alert({
            title: this.buildTitle(response.data.success),
            className: response.data.success
              ? "success-modal"
              : "failure-modal",
            message: response.data.message,
            callback: function () {
              window.location = redirectUrl;
            },
            closeButton: false
          });
        })
        .catch(error => {
          bootbox.alert({
            title: this.buildTitle(false),
            className: "failure-modal",
            message:
              "There is an error while processing your request, please make sure you entered correct details.",
            callback: function () {
              window.location = redirectUrl;
            },
            closeButton: false
          });
        });
    }
  }

  saveCreditCardirectDebit(event) {
    event.preventDefault();

    this.creditCardSubmitTarget.setAttribute("disabled", "disabled");
    const form = $(".bpoint_credit_card");
    const url = form.attr("action");
    const redirectUrl = form.data("redirectUrl");
    this.toggle_spinner(form);
    axios
      .patch(url, form.serialize())
      .then(response => {
        bootbox.alert({
          title: this.buildTitle(response.data.success),
          className: response.data.success ? "success-modal" : "failure-modal",
          message: response.data.message,
          callback: function () {
            window.location = redirectUrl;
          },
          closeButton: false
        });
        this.creditCardSubmitTarget.removeAttribute("disabled");
      })
      .catch(error => {
        bootbox.alert({
          title: this.buildTitle(false),
          className: "failure-modal",
          message:
            "There is an error while processing your request, please make sure you entered correct details.",
          callback: function () {
            window.location = redirectUrl;
          },
          closeButton: false
        });
        this.creditCardSubmitTarget.removeAttribute("disabled");
      });
  }

  buildTitle(success) {
    var icon_class = success
      ? `success-icon fas fa-check-circle`
      : `failed-icon fas fa-exclamation-triangle`;
    var icon_wrapper = `<i class='${icon_class}'></i>`;
    var return_message = `${icon_wrapper}${success ? "Success" : "Failed"}`;
    return return_message;
  }

  // hide current form and show spinner
  toggle_spinner(form) {
    const spinner_div = $(".direct-debit-processing-spinner");
    form.addClass("hide");
    spinner_div.removeClass("hide");
  }

  maskBsbInput() {
    var selector = document.querySelector(".bank-account-bsb");
    var im = new Inputmask("999-999");
    im.mask(selector);
  }
}
